import { RootState } from "store";

import { createSelector } from "@reduxjs/toolkit";

const getQuoteId = (state: RootState) => state.quote.id;
const getPendingPolicyId = (state: RootState) => state.pendingPolicy.id;

export const getHasPendingQuoteOrPolicy = createSelector(
  getQuoteId,
  getPendingPolicyId,
  (quoteId, pendingPolicyId) => !!quoteId || !!pendingPolicyId
);
